import { createRoot } from "react-dom/client";
import {useState, useRef, createContext, useEffect} from "react";
import { RenderLogs, Log } from "./../ms_audit_log";
import EmptyState from "./../ms_audit_log/components/EmptyState";
import Pagination from "./../../components/Pagination";
import Spinner from '@/react/components/Spinner';
import DatePicker from 'react-datepicker';
import axios from "axios";
import { PARSE_FORM_IN_ROVIEWER_FASHION } from "@/libraries/fk-data-table";


const Page = ({ payload }) => {
	const {eventData, orgData} = payload;

	const [pageDataLength, setPageDataLength] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [logData, setLogData] = useState([])
	const [isLoading, setIsLoading] = useState(true)
	const [formData, setFormData] = useState({});
	const [date, setDate] = useState('')
	// const [data, setData] = useState([])

	useEffect(()=>{
		fetchData();

	},[pageDataLength, currentPage, formData])

	const fetchData = async ()=>{
		try{
			setIsLoading(true);
			const response = await axios.get(`${BASE_URL}get-activity-logs?${formData}&page=${currentPage}&length=${pageDataLength}`, { headers: HEADER_OBJ });
			setLogData(response.data);
		}catch(err){
			console.error(err)
		}finally{
			setIsLoading(false)
		}
	}

	const handleDateChange = (val)=>{
		setDate(val);
	}

	const handleSubmit= async(e)=>{
		e.preventDefault();
		const formVal = PARSE_FORM_IN_ROVIEWER_FASHION(e.target)
		const queryString = new URLSearchParams(formVal).toString();
		setFormData(queryString)
        setCurrentPage(1)
	}

	if(logData.length < 1 && isLoading)
		return <Spinner />

	if(logData.length < 1)
		return <EmptyState message="No recent activity logged." />

	return (
		<div className="flex flex-col gap-5" disabled={isLoading}>
			<SearchForm handleSubmit={handleSubmit} date={date} orgData={orgData} eventData={eventData} handleDateChange={handleDateChange} />
			<RenderLogs data={logData} Component={DownloadLog}/>
			<Pagination totalCount={logData.total_count} length={pageDataLength} currentPage={currentPage} setLength={setPageDataLength} setCurrentPage={setCurrentPage} />
		</div>
	)
}
const SearchForm = ({handleSubmit, date, handleDateChange, eventData, orgData})=>{
	const activityList = useRef();
	const orgList = useRef();

	useEffect(()=>{
		if(activityList.current && orgList.current){
			const logDropdown = new MultiLayerDropdown(activityList.current, { searchPlaceholder: "Search by activity", levels: ["Activities"], keys: ["event"] });
			const orgDropdown = new MultiLayerDropdown(orgList.current, { searchPlaceholder: "Search by organization", levels: ["Organizations"], keys: ["org"] });
			logDropdown.initializeData(eventData);
			orgDropdown.initializeData(orgData);
		}
	}, []);

	return(
		<form onSubmit={handleSubmit} className="control-center">
			<div data-multi-select="false" data-duplicate-input-key-fields="true" id="activity" className="w-full" ref={activityList}></div>
			<div className="w-full [&>.react-datepicker-wrapper]:w-full [&>*>.react-datepicker-popper]:z-50">
				<DatePicker
					className="input-field"
					name="date"
					selected={date}
					popperPlacement="bottom-start"
					onChange={(date) => handleDateChange(date)}
					placeholderText="Pick founding date"
				/>
				{/*<input type="hidden" name="date" value={date ? date.toISOString() : ''} />*/}
			</div>
			<div data-multi-select="false" data-duplicate-input-key-fields="true" id="organization" className="w-full" ref={orgList}></div>
			<button type="submit" className="btn btn-icon-wide"><span className="material-symbols-rounded">search</span></button>
			<button type="reset" className="btn btn-icon-wide"><span className="material-symbols-rounded">cached</span></button>
		</form>
	)
}

const DownloadLog = ({ data: { child_data: logs, date } }) => {
	return (
		<div className="flex flex-col gap-3">
			<p className="text-article text-placeholderGray font-bold">{date}</p>
			<div className="relative overflow-hidden">
				<div className="dotted-line w-full"></div>
				<div className="flex flex-col gap-11 [&>div>div>.log-disc]:flex [&>div>div>.log-disc]:justify-between [&>div>div>.log-disc>.text-primary]:text-black">
					{logs.map((d, i) => <Log timeLength="full" meridiem={false} key={i} data={d} />)}
				</div>
			</div>
		</div>
	)
}


function initPage(selector, payload) {
	createRoot(document.querySelector(selector)).render(
		<Page payload={payload} />
	);
}

export default initPage;
